import { createGlobalState, useStorage } from '@vueuse/core'
import { WEPIN_TOKEN } from '@/const'

export const useGlobalState = createGlobalState(() =>
  useStorage(WEPIN_TOKEN, ''),
)
